<template>
  <Section id="multiple-barcode-view">
    <div class="inner-navbar">
      <el-form
        :inline="true"
        class="barcode-form-inline d-flex align-items-center"
      >
        <el-form-item>
          <el-button
            @click="onPrint"
            :title="printButtonTitle"
            type="button"
            class="print-btn"
          >
            <span class="el-icon-printer"></span>Print Barcodes
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="inner-content">
        <div class id="barcodesBody">
          <div style="margin-top: 20px" class="each-barcode">
            <div class="barcode">
              <div class="show-barcode">
                <el-row>
                  <el-col :span="24">
                    <div class="barcode-body" id="barcodeBody">
                      <div v-if="this.ids.length === 1">
                        <div
                          class="bar-code-table"
                          v-if="this.ids.includes('1')"
                        >
                          <div
                            class="bar-code-table-inner"
                            style="padding: 5px 10px"
                          >
                            <table
                              style="
                                width: 100%;
                                padding: 1em;
                                max-width: 550px;
                              "
                            >
                              <tbody>
                                <tr style="vertical-align: baseline">
                                  <th
                                    class="patient-name-block"
                                    style="
                                      text-align: left;
                                      text-transform: uppercase;
                                    "
                                  >
                                    <div class="patient-name">Negative</div>
                                    <div class="patient-name">Control</div>
                                  </th>
                                  <th class="date-column">
                                    <div class="dates">
                                      <p
                                        class="doc-dates"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        DOC:
                                        {{
                                          momentWithTimezone(
                                            this.date,
                                            "MM-DD-YYYY"
                                          )
                                        }}
                                      </p>
                                      <p
                                        class="dob-date"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        <span>
                                          DOB:
                                          {{
                                            momentWithTimezone(
                                              this.date,
                                              "MM-DD-YYYY"
                                            )
                                          }}
                                        </span>
                                      </p>
                                    </div>
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                            <div class="content">
                              <el-row>
                                <el-col :span="24">
                                  <div class="image">
                                    <BarcodeGenerator
                                      value="LEVEL1"
                                      font="arial"
                                      font-size="18"
                                      height="76"
                                      :width="1.4"
                                      display-value="false"
                                      :margin="0"
                                    />
                                  </div>
                                  <div
                                    class="assession-id"
                                    style="
                                      text-align: center;
                                      font-size: 11.953325px !important;
                                      font-weight: 600;
                                      letter-spacing: 0.15pt;
                                      line-height: 1;
                                    "
                                  >
                                    LEVEL1
                                  </div>
                                  <div class="case-types">
                                    <b>URINALYSIS</b>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </div>
                        <div
                          class="bar-code-table"
                          v-if="this.ids.includes('2')"
                        >
                          <div
                            class="bar-code-table-inner"
                            style="padding: 5px 10px"
                          >
                            <table
                              style="
                                width: 100%;
                                padding: 1em;
                                max-width: 550px;
                              "
                            >
                              <tbody>
                                <tr style="vertical-align: baseline">
                                  <th
                                    class="patient-name-block"
                                    style="
                                      text-align: left;
                                      text-transform: uppercase;
                                    "
                                  >
                                    <div class="patient-name">Positive</div>
                                    <div class="patient-name">Control</div>
                                  </th>
                                  <th class="date-column">
                                    <div class="dates">
                                      <p
                                        class="doc-dates"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        DOC:
                                        {{
                                          momentWithTimezone(
                                            this.date,
                                            "MM-DD-YYYY"
                                          )
                                        }}
                                      </p>
                                      <p
                                        class="dob-date"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        <span>
                                          DOB:
                                          {{
                                            momentWithTimezone(
                                              this.date,
                                              "MM-DD-YYYY"
                                            )
                                          }}
                                        </span>
                                      </p>
                                    </div>
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                            <div class="content">
                              <el-row>
                                <el-col :span="24">
                                  <div class="image">
                                    <BarcodeGenerator
                                      value="LEVEL2"
                                      font="arial"
                                      font-size="18"
                                      height="76"
                                      :width="1.4"
                                      display-value="false"
                                      :margin="0"
                                    />
                                  </div>
                                  <div
                                    class="assession-id"
                                    style="
                                      text-align: center;
                                      font-size: 11.953325px !important;
                                      font-weight: 600;
                                      letter-spacing: 0.15pt;
                                      line-height: 1;
                                    "
                                  >
                                    LEVEL2
                                  </div>
                                  <div class="case-types">
                                    <b>URINALYSIS</b>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="this.ids.length === 2">
                        <div class="bar-code-table">
                          <div
                            class="bar-code-table-inner"
                            style="padding: 5px 10px"
                          >
                            <table
                              style="
                                width: 100%;
                                padding: 1em;
                                max-width: 550px;
                              "
                            >
                              <tbody>
                                <tr style="vertical-align: baseline">
                                  <th
                                    class="patient-name-block"
                                    style="
                                      text-align: left;
                                      text-transform: uppercase;
                                    "
                                  >
                                    <div class="patient-name">Negative</div>
                                    <div class="patient-name">Control</div>
                                  </th>
                                  <th class="date-column">
                                    <div class="dates">
                                      <p
                                        class="doc-dates"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        DOC:
                                        {{
                                          momentWithTimezone(
                                            this.date,
                                            "MM-DD-YYYY"
                                          )
                                        }}
                                      </p>
                                      <p
                                        class="dob-date"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        <span>
                                          DOB:
                                          {{
                                            momentWithTimezone(
                                              this.date,
                                              "MM-DD-YYYY"
                                            )
                                          }}
                                        </span>
                                      </p>
                                    </div>
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                            <div class="content">
                              <el-row>
                                <el-col :span="24">
                                  <div class="image">
                                    <BarcodeGenerator
                                      value="LEVEL1"
                                      font="arial"
                                      font-size="18"
                                      height="76"
                                      :width="1.4"
                                      display-value="false"
                                      :margin="0"
                                    />
                                  </div>
                                  <div
                                    class="assession-id"
                                    style="
                                      text-align: center;
                                      font-size: 11.953325px !important;
                                      font-weight: 600;
                                      letter-spacing: 0.15pt;
                                      line-height: 1;
                                    "
                                  >
                                    LEVEL1
                                  </div>
                                  <div class="case-types">
                                    <b>URINALYSIS</b>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </div>
                        <div class="bar-code-table">
                          <div
                            class="bar-code-table-inner"
                            style="padding: 5px 10px"
                          >
                            <table
                              style="
                                width: 100%;
                                padding: 1em;
                                max-width: 550px;
                              "
                            >
                              <tbody>
                                <tr style="vertical-align: baseline">
                                  <th
                                    class="patient-name-block"
                                    style="
                                      text-align: left;
                                      text-transform: uppercase;
                                    "
                                  >
                                    <div class="patient-name">Positive</div>
                                    <div class="patient-name">Control</div>
                                  </th>
                                  <th class="date-column">
                                    <div class="dates">
                                      <p
                                        class="doc-dates"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        DOC:
                                        {{
                                          momentWithTimezone(
                                            this.date,
                                            "MM-DD-YYYY"
                                          )
                                        }}
                                      </p>
                                      <p
                                        class="dob-date"
                                        style="
                                          margin: 0;
                                          text-align: right;
                                          font-weight: 500;
                                        "
                                      >
                                        <span>
                                          DOB:
                                          {{
                                            momentWithTimezone(
                                              this.date,
                                              "MM-DD-YYYY"
                                            )
                                          }}
                                        </span>
                                      </p>
                                    </div>
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                            <div class="content">
                              <el-row>
                                <el-col :span="24">
                                  <div class="image">
                                    <BarcodeGenerator
                                      value="LEVEL2"
                                      font="arial"
                                      font-size="18"
                                      height="76"
                                      :width="1.4"
                                      display-value="false"
                                      :margin="0"
                                    />
                                  </div>
                                  <div
                                    class="assession-id"
                                    style="
                                      text-align: center;
                                      font-size: 11.953325px !important;
                                      font-weight: 600;
                                      letter-spacing: 0.15pt;
                                      line-height: 1;
                                    "
                                  >
                                    LEVEL2
                                  </div>
                                  <div class="case-types">
                                    <b>URINALYSIS</b>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <!-- If already  having borcode Or after generated barcode -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Section>
</template>

<script>
import BarcodeGenerator from "./BarcodeGenerator.vue";
export default {
  data() {
    return {
      date: new Date(),
      generateSecondBarcode: false,
      ids: [],
    };
  },
  mounted() {
    const ids = this.$route.query.ids;
    if (ids) {
      this.ids = Array.isArray(ids) ? ids : [ids];
    } else {
      this.ids = [];
    }
  },
  methods: {
    async onPrint() {
      // await this.$htmlToPaper("barcodesBody");
      window.print();
    },
  },
  components: {
    BarcodeGenerator,
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap");
#multiple-barcode-view {
  padding: 2em 0;
  margin-top: 5vh;
  font-family: "Open Sans", sans-serif;
  @page {
    size: A4;
    margin: 0 auto;
    width: 288px;
    // margin: 0 auto;
    height: 192px;
  }
  .number-counter {
    .el-input__inner {
      padding-right: 0 !important;
      font-weight: 500;
      color: #000;
      font-size: 15px;
    }
  }
  .each-barcode {
    margin-top: 0 !important;
    page-break-inside: avoid;
    page-break-after: avoid;
  }
  .barcode-form-inline {
    .el-form-item {
      margin-bottom: 0;
    }
    margin-bottom: 45px;
  }
  #barcodeBody {
    .bar-code-table {
      width: 288px;
      margin: 4.85em auto;
      height: 192px;
      overflow: hidden;
      padding: 0;
      transform: rotate(90deg);
      table {
        padding: 10px 5px 0 10px !important;
      }
      th {
        font-size: 14px;
      }
      .designation {
        margin-top: 0;
      }
      .dates {
        p {
          line-height: 20px;
          font-size: 13px;
        }
      }
      .image {
        img {
          max-width: 200px;
          margin: 0 auto;
        }
        &.diasorin {
          img {
            max-width: 180px;
          }
        }
      }
    }
  }
  .inner-navbar {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    margin-right: 10px;
    .print-btn {
      background: #6f52ed;
      padding: 9px 15px;
      color: #fff;
      font-size: 1em;
      span {
        padding-right: 5px;
      }
    }
  }
  .inner-content {
    .bar-code-table {
      background: #fff;
      padding: 10px;
      .image {
        display: table;
        margin: 0 auto;
        max-width: 100% !important;
      }
      .case-types {
        text-align: center;
        b {
          font-size: 15px;
        }
      }
      table {
        margin: 0 auto;
      }
    }
  }
  .each-barcode {
    display: table;
    margin: 20px auto;
    margin-bottom: 20px;
  }
  @media print {
    .each-barcode {
      margin: 0 !important;
      display: block !important;
    }
    .inner-navbar {
      display: none !important;
      margin-top: 0 !important;
      margin-right: 0 !important;
    }
  }

  // @media print {
  #barcodeBody .bar-code-table {
    page-break-before: always;
    margin-bottom: 120px !important;
    margin-left: -48px !important;
    margin-right: 0 !important;
    background: #fff !important;
    margin-top: 48px !important;
    display: flex;
    align-items: flex-end;
  }
  .designation {
    margin-top: 0 !important;
    font-size: 8px !important;
  }
  #barcodeBody .bar-code-table .image img {
    margin-bottom: -5px;
  }
  #barcodeBody .bar-code-table #assession-id {
    text-align: center;
    font-size: 7pt !important;
    font-weight: 500;
    letter-spacing: 0.15pt;
    line-height: 1;
    padding-bottom: 0;
    margin-bottom: -20px;
  }
  #barcodeBody .bar-code-table th {
    font-size: 7px !important;
    font-weight: normal;
    letter-spacing: 0.1px;
  }
  #barcodeBody .bar-code-table .patient-name-block {
    padding-top: 10px;
  }
  #barcodeBody .bar-code-table .date-column {
    width: 95px;
  }
  #barcodeBody .bar-code-table .patient-name {
    font-size: 9px;
    font-weight: 400;
    line-height: 11px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    letter-spacing: 0;
  }
  #barcodeBody .bar-code-table .dates {
    font-size: 8pt;
    font-weight: 700;
    padding-right: 15px;
  }
  #barcodeBody .bar-code-table .dates p {
    line-height: 12px;
    font-size: 10px !important;
    width: 95px;
    font-weight: 800;
    letter-spacing: 0.2px;
  }
  .inner-content .bar-code-table .case-types b {
    font-size: 11px !important;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 1;
    padding-top: 0;
    margin: -10px 0 0 !important;
  }
  .bar-code-table-inner {
    width: 100%;
    padding: 10px 10px 6px 30px !important;
  }
  .patient-name-block {
    padding-left: 15px;
  }
  padding-top: 0 !important;

  #multiple-barcode-view {
    padding-top: 0;
  }
}
.no-barcode {
  text-align: center;
  font-size: 1.1em;
}
.bar-code-table-inner {
  padding-bottom: 10px !important;
}
#multiple-barcode-view .inner-content .bar-code-table .case-types {
  line-height: 10px;
}
</style>
